import { useEffect, useState } from 'react';
import { Input } from 'src/components/UI/Forms/Inputs';
import {
  DEFAULT_ESCORT,
  Escort,
} from 'src/utils/interfaces/interfaces';
import {
  useAddUserMutation,
  useGetEscortListQuery,
  useSearchEscortByNameQuery,
  useUpdateUserMutation,
} from 'src/services/transporterDrivers/transporterDrivers';
import {
  FullName,
  EmailOptional,
  SelectAnyValue,
  PhoneRequired,
  Required,
} from 'src/utils/validations/formValidations';
import PhoneInput from 'src/components/UI/Forms/Inputs/phoneInput';
import { useForm } from 'react-hook-form';
import DatePickerComponent from 'src/components/UI/Forms/Inputs/datePicker';
import { getUser } from 'src/utils/user/user';
import CustomSnackbar from 'src/components/UI/Alerts/customSnackbar';
import CustomSelect from 'src/components/UI/Forms/Inputs/customSelect';
import { Countries } from 'src/data/Countries';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  Modal,
} from '@heroui/react';
import { FaPlus } from 'src/icons';
import DriverCard from 'src/components/Driver/driverCard';
import FileUpload from 'src/components/UI/Forms/Inputs/fileUpload';
import { EscortList } from 'src/components/Transporter/escortList';
import EscortCard from 'src/components/Transporter/escortCard';

export interface IMembersProps { }
export function Escorts(props: IMembersProps) {
  const [showEscort, setShowEscort] = useState(false);
  const [showAddEscort, setShowAddEscort] = useState(false);
  const [showEditEscort, setShowEditEscort] = useState(false);
  const user = getUser();
  const { data: Escort, refetch: refetchEscort } = useGetEscortListQuery(
    user.company._id
  );
  const [searchString, setSearchString] = useState('');
  const [dlExpiryDate, setDlExpiryDate] = useState<Date | null>(null);
  const [siraIdFile, setSiraIdFile] = useState<File | null>(null);
  const [isDateError, setIsDateError] = useState(false);
  const [selectedEscort, setSelectedEscort] = useState<Escort>(DEFAULT_ESCORT);
  const [escortFullData, setEscortFullData] = useState<any>([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [countryDialCode, setCountryDialCode] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<
    'success' | 'info' | 'warning' | 'error'
  >('success');
  const { data: driverFirstFiltered } = useSearchEscortByNameQuery(
    { companyId: user.company._id, search: searchString },
    {
      skip: !searchString,
    }
  );
  const [addEscort] = useAddUserMutation();
  const [updateEscort] = useUpdateUserMutation();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const onChangeSearch = (searchString: any) => {
    setSearchString(searchString);
  };

  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    fileType: string
  ) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      switch (fileType) {
        case 'siraIdFile':
          setSiraIdFile(file);
          break;
        default:
          console.warn('Unknown file type:', fileType);
      }
    }
  };

  useEffect(() => {
    if (searchString === '') {
      setEscortFullData(Escort);
    }
    setEscortFullData(Escort);
  }, [Escort, searchString]);
  useEffect(() => {
    if (searchString !== '') {
      setEscortFullData(Escort);
      setEscortFullData(driverFirstFiltered);
    }
  }, [driverFirstFiltered]);

  const onAddEscort = (data: any) => {
    data['siraIdFile'] = siraIdFile;
    data['designation'] = 'escort';
    let user = window.localStorage.getItem('user');
    if (user) {
      let companyDetails = JSON.parse(user);
      var companyId = companyDetails?.company?._id;
    }
    data['type'] = 'escort';
    data['company'] = companyId;
    data['phone'] = (countryDialCode || '+971') + data.phone;
    data['status'] = 'active';
    data['reviewed'] = 'true';

    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (data[key] !== undefined && data[key] !== null && data[key] !== '') {
        formData.append(key, data[key]);
      }
    });

    addEscort(formData)
      .then((response: any) => {
        if (response.data) {
          setSnackbarMessage('Escort added successfully');
          setSnackbarSeverity('success');
          setOpenSnackbar(true);
          setShowAddEscort(false);
          refetchEscort();
          reset();
          setDlExpiryDate(null);
          setCountryDialCode('');
        } else if (response.error) {
          setSnackbarMessage(
            response.error.data.message
              ? response.error.data.message
              : 'Something went wrong.'
          );
          setSnackbarSeverity('error');
          setOpenSnackbar(true);
        }
      })
      .catch((error: any) => {
        // Catch block for handling genuine errors
        setSnackbarMessage('Something went wrong.');
        setSnackbarSeverity('error');
        setOpenSnackbar(true);
        setShowAddEscort(false);
        refetchEscort();
        reset();
        setDlExpiryDate(null);
      });
  };

  const onUpdateDriver = (data: any) => {
    if (!dlExpiryDate) {
      setIsDateError(true);
      return;
    }
    setIsDateError(false);

    data['dlExpiry'] = dlExpiryDate.toISOString().slice(0, 10);
    data['designation'] = 'escort';
    let user = window.localStorage.getItem('user');
    if (user) {
      let companyDetails = JSON.parse(user);
      var companyId = companyDetails?.company?._id;
    }
    data['type'] = 'escort';
    data['company'] = companyId;
    let _payload = data;
    _payload.phone = (countryDialCode || '+971') + data.phone;
    updateEscort({ data: _payload, id: selectedEscort._id })
      .then((response: any) => {
        if (response.data) {
          setSnackbarMessage('Escort updated successfully');
          setSnackbarSeverity('success');
          setOpenSnackbar(true);
          setShowAddEscort(false);
          refetchEscort();
          reset();
          setDlExpiryDate(null);
          setCountryDialCode('');
          setShowEditEscort(false);
        } else if (response.error) {
          setSnackbarMessage(
            response.error.data.message
              ? response.error.data.message
              : 'Something went wrong.'
          );
          setSnackbarSeverity('error');
          setOpenSnackbar(true);
        }
      })
      .catch((error: any) => {
        // Catch block for handling genuine errors
        setSnackbarMessage('Something went wrong.');
        setSnackbarSeverity('error');
        setOpenSnackbar(true);
        setShowAddEscort(false);
        refetchEscort();
        reset();
        setDlExpiryDate(null);
      });
  };

  const onEditDriver = (data: any) => {
    setShowEditEscort(true);
    setShowEscort(false);
  };

  const { t } = useTranslation();

  return (
    <>
      <div className="w-full h-screen px-6 overflow-y-auto pt-4" style={{ backgroundColor: "var(--bg-base)", color: "var(--text-main)" }}>
        <CustomSnackbar
          open={openSnackbar}
          handleClose={() => setOpenSnackbar(false)}
          message={snackbarMessage}
          severity={snackbarSeverity}
          anchorOrigin={{ vertical: 'top', horizontal: 'end' }}
        />
        <div className="sticky top-0 z-10 py-4 pb-4" style={{ backgroundColor: "var(--bg-base)" }}>
          <div className="flex items-center justify-between">
            <h3 className="text-2xl ms-4">{t('nav_bar.escorts')}</h3>
            <div className="flex justify-end gap-4">
              <Button
                variant="solid"
                size="sm"
                className="rounded-md shadow-lg m-1 px-5 py-2 font-semibold text-sm transition-colors"
                style={{ backgroundColor: 'var(--color-primary)', color: 'var(--text-invert)' }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'var(--color-primary-hover)')}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'var(--color-primary)')}
                onPress={() => setShowAddEscort(true)}
                startContent={<FaPlus />}
              >
                {t('escort.add_escort')}
              </Button>
              <Input
                type="text"
                placeholder={t('escort.search_placeholder')}
                inputClassName="bg-[var(--bg-surface-2)] border border-[var(--border-light)] shadow-sm rounded-lg placeholder:text-[var(--text-muted)] text-[var(--text-main)] h-[45px]"
                onChange={(e: any) => onChangeSearch(e.target.value)}
                iconUrl="/assets/icons/search.svg"
              ></Input>
            </div>
          </div>
        </div>
        <section>
          {/* {filteredOrders &&
            filteredOrders.map((order: Order, count: number) => (
              <OrderCard
                order={order}
                key={count}
                onClick={() => navigate(`/orders/${order._id}`)}
              />
            ))} */}
        </section>
        <section>
          <div className="rounded-lg max-h-[70vh] overflow-y-auto">
            {escortFullData && escortFullData.length !== 0 ? (
              escortFullData?.response
                ?.filter((user: Escort) => {
                  const searchTerm = searchString.toLowerCase();
                  const fullName =
                    `${user.firstName} ${user.lastName}`.toLowerCase();
                  return (
                    fullName.includes(searchTerm) ||
                    user.phone.includes(searchTerm)
                  );
                })
                .map((user: Escort) => (
                  <EscortList
                    key={user._id}
                    escort={user}
                    onAction={(escort: Escort) => {
                      setSelectedEscort(escort);
                      setShowEscort(true);
                    }}
                    onClose={() => {
                      setShowEscort(false);
                    }}
                  />
                ))
            ) : (
              <div className="px-6">
                <div className="sticky top-0 z-10 flex flex-col items-center py-8 pb-4 mt-48">
                  <h3 className="col-span-2 mt-10 mb-2 text-2xl tracking-wide text-center">
                    {t('escort.no_escort')}
                  </h3>
                  <div className="w-[100px] mt-2 h-1 bg-gradient-to-r from-white/[0] via-[var(--color-primary)] to-white/[0]"></div>
                </div>
              </div>
            )}
          </div>
        </section>
      </div>
      {/* ==================================================ADD DRIVER=========================================== */}
      <Drawer
        isOpen={showAddEscort}
        onClose={() => {
          setShowAddEscort(false);
          reset();
        }}
        className="w-1/3 shadow-card" style={{ backgroundColor: "var(--bg-surface)", color: "var(--text-main)" }}
        classNames={{
          closeButton:
            'bg-[var(--bg-overlay)] m-2 hover:bg-[var(--bg-surface-2)] text-[var(--text-main)] p-2',
          header: 'px-6',
        }}
      >
        <DrawerContent>
          {(onClose) => (
            <>
              <DrawerHeader className="flex flex-col gap-1 text-[var(--text-main)] text-2xl font-bold">
                {t('escort.add_escort')}
              </DrawerHeader>
              <DrawerBody>
                <form className="h-[80vh] overflow-y-scroll pe-5">
                  <Input
                    type="text"
                    name="firstName"
                    label={t('user.first_name')}
                    placeholder="Mohammed"
                    className="!mb-6"
                    inputClassName="bg-[var(--bg-surface-2)] border border-[var(--border-light)] shadow-sm text-[var(--text-main)] placeholder:text-[var(--text-muted)]"
                    register={register}
                    validation={FullName}
                    error={errors.firstName}
                    errorText={t('user.error_messages.first_name')}
                  />
                  <Input
                    type="text"
                    name="lastName"
                    label={t('user.last_name')}
                    placeholder="Ali"
                    className="!mb-6"
                    inputClassName="bg-[var(--bg-surface-2)] border border-[var(--border-light)] shadow-sm text-[var(--text-main)] placeholder:text-[var(--text-muted)]"
                    register={register}
                    validation={FullName}
                    error={errors.lastName}
                    errorText={t('user.error_messages.last_name')}
                  />
                  <PhoneInput
                    type="tel"
                    name="phone"
                    label={t('user.contact_number')}
                    placeholder="55XXXXXXX"
                    className="!mb-6"
                    inputClassName="bg-[var(--bg-surface-2)] border border-[var(--border-light)] shadow-sm text-[var(--text-main)] placeholder:text-[var(--text-muted)]"
                    prefixClassName="bg-[var(--bg-surface-2)] border border-[var(--border-light)] shadow-sm text-[var(--text-main)] placeholder:text-[var(--text-muted)] w-full"
                    register={register}
                    validation={PhoneRequired}
                    error={errors.phone}
                    errorText={t('user.error_messages.phone_number')}
                    onCountryCodeChange={(selectedCode) => {
                      setCountryDialCode(selectedCode);
                    }}
                  />
                  <Input
                    type="email"
                    name="email"
                    label={t('user.email')}
                    placeholder="example@domain.com"
                    className="!mb-6"
                    inputClassName="bg-[var(--bg-surface-2)] border border-[var(--border-light)] shadow-sm text-[var(--text-main)] placeholder:text-[var(--text-muted)]"
                    register={register}
                    validation={EmailOptional}
                    error={errors.email}
                    errorText={t('user.error_messages.email')}
                  />
                  <Input
                    type="text"
                    name="siraId"
                    label="SIRA ID"
                    placeholder="Enter a valid SIRA ID"
                    className="!mb-9"
                    inputClassName="bg-[var(--bg-surface-2)] border border-[var(--border-light)] shadow-sm text-[var(--text-main)] placeholder:text-[var(--text-muted)]"
                    register={register}
                    validation={FullName}
                    error={errors.siraId}
                    errorText="Enter a valid SIRA ID"
                  />
                  <FileUpload
                    id="siraIdFile"
                    name="siraIdFile"
                    label="SIRA ID"
                    inputClassName="bg-[var(--bg-surface-2)] border border-dashed border-[var(--border-light)] rounded-lg text-[var(--text-main)] placeholder:text-[var(--text-muted)]"
                    className="!mb-6"
                    placeholder="Upload SIRA ID"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      handleFileChange(e, 'siraIdFile')
                    }
                    register={register}
                    allowedFileTypes={[
                      'image/png',
                      'image/jpeg',
                      'application/pdf',
                    ]} // Allowed types
                    maxFileSize={1024 * 1024} // Max file size 1MB
                    validation={Required}
                    error={errors.siraIdFile}
                    errorText="SIRA ID is required"
                  />
                  {/* <DatePickerComponent
                    selectedDate={dlExpiryDate}
                    onChange={setDlExpiryDate}
                    isDateError={isDateError}
                    minDate={new Date()}
                    label={t('driver.license_expiry')}
                    placeholder="MM/DD/YYYY"
                    errorText={t('user.error_messages.license_expiry')}
                    className="!mb-4"
                  /> */}
                  <CustomSelect
                    name="nationality"
                    label={t('user.nationality')}
                    labelClassName="!text-blue/[0.7] !mb-2"
                    options={Countries}
                    placeholder={t('user.nationality')}
                    className="mb-5"
                    selectClassName="bg-[var(--bg-surface-2)] border border-[var(--border-light)] shadow-sm placeholder:text-[var(--text-muted)] text-[var(--text-main)]"
                    register={register}
                    validation={SelectAnyValue}
                    setValue={setValue}
                    error={errors.nationality}
                    errorText={t('user.error_messages.nationality')}
                  ></CustomSelect>
                </form>
              </DrawerBody>
              <DrawerFooter className="m-auto">
                <Button
                  variant="solid"
                  size="md"
                  className="p-3 shadow-lg w-36 font-semibold transition-colors"
                  style={{ backgroundColor: 'var(--color-primary)', color: 'var(--text-invert)' }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'var(--color-primary-hover)')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'var(--color-primary)')}
                  onClick={handleSubmit((d) => onAddEscort(d))}
                >
                  {t('escort.add_escort')}
                </Button>
              </DrawerFooter>
            </>
          )}
        </DrawerContent>
      </Drawer>
      <Modal
        isOpen={showEditEscort}
        onClose={() => setShowEditEscort(false)}
        className="w-1/3 shadow-card" style={{ backgroundColor: "var(--bg-surface)", color: "var(--text-main)" }}
      >
        <div className="h-screen">
          <div className="p-8 pb-0">
            <img
              onClick={() => setShowEditEscort(false)}
              src="/assets/icons/cross.svg"
              alt="close"
              className="float-right cursor-pointer"
            ></img>
            <h3 className="mb-10 text-2xl text-white">Edit Driver</h3>
            <form
              key={selectedEscort._id || 'new'}
              className="h-[80vh] overflow-y-scroll pe-5 pb-16"
            >
              <Input
                type="text"
                name="firstName"
                label="First Name"
                placeholder="Mohammed"
                className="!mb-9"
                inputClassName="bg-white/[0.04] border-white/[0.3] text-white placeholder:opacity-30"
                register={register}
                validation={FullName}
                defaultValue={selectedEscort.firstName || ''}
                error={errors.firstName}
                errorText="Enter a valid First Name"
              />
              <Input
                type="text"
                name="lastName"
                label="Last Name"
                placeholder="Ali"
                className="!mb-9"
                inputClassName="bg-white/[0.04] border-white/[0.3] text-white placeholder:opacity-30"
                register={register}
                validation={FullName}
                defaultValue={selectedEscort.lastName || ''}
                error={errors.lastName}
                errorText="Enter a valid Last Name"
              />
              <PhoneInput
                type="tel"
                name="phone"
                label="Phone number "
                placeholder="55XXXXXXX"
                className="!mb-16"
                inputClassName="bg-white/[0.04] border-white/[0.3] text-white placeholder:opacity-30"
                prefixClassName="bg-white/[0.04] border border-white/[0.3] text-white placeholder:opacity-30 w-full"
                register={register}
                validation={PhoneRequired}
                defaultValue={selectedEscort.phone || ''}
                error={errors.phone}
                errorText="Enter a valid Phone Number"
                onCountryCodeChange={(selectedCode) => {
                  setCountryDialCode(selectedCode);
                }}
              />
              <Input
                type="email"
                name="email"
                label="Email (optional)"
                placeholder="Enter your email"
                className="!mb-9"
                inputClassName="bg-white/[0.04] border-white/[0.3] text-white placeholder:opacity-30"
                register={register}
                validation={EmailOptional}
                defaultValue={selectedEscort.email || ''}
                error={errors.email}
                errorText="Enter a valid Email Address"
              />
              <Input
                type="text"
                name="siraId"
                label="SIRA ID"
                placeholder="Enter a valid SIRA ID"
                className="!mb-9"
                inputClassName="bg-white/[0.04] border-white/[0.3] text-white placeholder:opacity-30"
                register={register}
                validation={FullName}
                defaultValue={selectedEscort.siraId || ''}
                error={errors.siraId}
                errorText="Enter a valid SIRA ID"
              />
              <CustomSelect
                name="nationality"
                label="Country"
                labelClassName="!text-blue/[0.7] !mb-2"
                options={Countries}
                placeholder="Select nationality"
                className="mb-8"
                selectClassName="shadow-sm border border-[var(--border-light)] placeholder:text-[var(--text-muted)] text-[var(--text-main)]"
                register={register}
                validation={SelectAnyValue}
                setValue={setValue}
                defaultValue={selectedEscort.nationality || ''}
                error={errors.nationality}
                errorText="Select a country"
              ></CustomSelect>
            </form>
          </div>
          <div className="absolute bottom-0 z-50 w-full px-8 pt-3 pb-8 shadow-md" style={{ backgroundColor: "var(--bg-surface)", borderTop: "1px solid var(--border-light)" }}>
            <button
              className="w-full p-3 text-white rounded-lg"
              onClick={handleSubmit((d) => onUpdateDriver(d))}
            >
              Save
            </button>
          </div>
        </div>
      </Modal>
      {/* ================================================================================================================== */}
      <Drawer
        isOpen={showEscort}
        onClose={() => setShowEscort(false)}
        className="w-[30%] shadow-card" style={{ backgroundColor: "var(--bg-surface)", color: "var(--text-main)" }}
        classNames={{
          closeButton:
            'bg-white/[0.06] m-2 hover:bg-white/[0.09] active:bg-white/[0.06] text-white p-2',
          header: 'px-6',
        }}
      >
        <DrawerContent>
          {(onClose) => (
            <>
              <DrawerHeader className="flex flex-col gap-1 text-[var(--text-main)] text-2xl font-bold">
                {t('driver.driver_details')}
              </DrawerHeader>
              <DrawerBody>
                <div className="px-2 py-10 text-white">
                  <EscortCard Escort={selectedEscort} />
                </div>
              </DrawerBody>
              <DrawerFooter className="m-auto">
                <Button
                  variant="flat"
                  onPress={onClose}
                  className="text-[var(--text-muted)] hover:bg-[var(--color-error)]/10 hover:text-[var(--color-error)] border border-[var(--border-light)]"
                >
                  {t('button.close')}
                </Button>
              </DrawerFooter>
            </>
          )}
        </DrawerContent>
      </Drawer>
    </>
  );
}
